import {ChartOptions} from "../config/ChartOptions";
import ChartBox from "../chart";
import Chart from "chart.js"
import ChartInteractions from "./chart";
import {merge} from "lodash"
import {PrintOptions} from "../config/ChartOptions";

export class ProductPrinterObject extends ChartBox {

  chart = null

  init() {
    this.chart = new Chart(
      this.canvas.getContext('2d'),
      this.getPrintOptions()
    )
  }

  getPrintOptions() {

    const nid = this.$refs.chart.dataset.productId
    const collectionName = this.$refs.chart.dataset.collectionName ?? 'cooling_performances'

    return merge(
      this.resolveChartOptions(nid, collectionName),
      PrintOptions()
    )

  }

  resolveChartOptions(nid, collectionName) {
    return ChartOptions(
      ChartInteractions.resolveDatasetForOneProduct(nid, collectionName),
      null,
      collectionName
    )
  }


}

const ProductPrinter = () => {
  return new ProductPrinterObject()
}


export default ProductPrinter
